<template>
  <componentCreateExam previewExamName="paper-detail" backRouteName="exam-management" />
</template>
<script>
import componentCreateExam from '@/components/PracticeAndExam/createExam.vue'
export default {
  name: 'create-exam',
  components: {
    componentCreateExam
  }
}
</script>